export default __webpack_public_path__ + "static/media/close-icon-white.607cd369.svg";